type Props = {
  visible?: boolean;
};

export function PhotoLoad({ visible = true }: Props) {
  if (!visible) {
    return null;
  }

  // TODO: Add timeout logic
  return (
    <div className="App AppLoad">
      <div className="spinner--wv-star">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    </div>
  );
}

export default PhotoLoad;
